// extracted by mini-css-extract-plugin
module.exports = {"page-seo":"_2cGQ","page-content-wrap":"_2xzq","data-list":"_2Wj2","page-seo-content-wrap":"_3vW4"};